module.exports = __webpack_public_path__ + "img/agp.a5e11063.jpg";